// ============================================
// PLACEHOLDER IMAGES
// Use these when actual images aren't available yet
// Replace the imports in content.js with actual images
// ============================================

// Generate placeholder SVG data URLs
const createPlaceholder = (width, height, text, bgColor = '#2B4B8C') => {
    const svg = `
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="${bgColor}"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-family="sans-serif" font-size="14">
        ${text}
      </text>
    </svg>
  `
    return `data:image/svg+xml,${encodeURIComponent(svg.trim())}`
}

// Placeholder images
export const PLACEHOLDER_IMAGES = {
    logo: '/images/csforeachlogo.svg',
    background: '/images/About1.png',
    graphic1: '/images/ClubPhoto2.png',
    graphic2: '/images/ClubPhoto5.png',
    graphic3: '/images/ClubPhoto4.png',
    about: '/images/About1.png',
    impact: '/images/Curriculum3.png',
    tritonhacks: '/images/TritonHacksLogo.png',
    curriculum: '/images/Curriculum6.png',
    earlystart: '/images/TritonHacks4.png',
    discord: createPlaceholder(39, 40, 'D', '#5865F2'),
    instagram: createPlaceholder(39, 40, 'I', '#E4405F'),
    linkedin: createPlaceholder(39, 40, 'L', '#0A66C2'),
    email: createPlaceholder(39, 40, '@', '#EA4335'),
}

export default PLACEHOLDER_IMAGES
